/** Message type for RN WebView — must match bedbooking_react_native `webViewNavigateHome`. */
export const BB_NAVIGATE_HOME = 'BB_NAVIGATE_HOME'
